







































import {
	defineComponent,
	PropType,
	ref,
	watch,
} from '@vue/composition-api';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import { InvitationCampaignInvitee } from '@front-app/services/GroupInvitationCampaignApi/model';
import { InvitationCampaignInviteesStore } from '@front-app/store/singletons/InvitationCampaignInvitees';
import { Size } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';

export default defineComponent({
	components: {
		ErrorCard,
		LoaderState,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		campaignId: {
			type: String,
			required: true,
		},
		selectedInvitee: {
			type: Object as PropType<InvitationCampaignInvitee>,
			required: true,
		},
	},
	setup(props) {
		const invitationDates = ref([] as Date[]);

		const { track, isLoading, isError } = useAsyncStatus();
		watch(() => props.selectedInvitee.inviteeId, async (newVal, prevVal) => {
			if (newVal !== prevVal) {
				const result = await track(InvitationCampaignInviteesStore.fetchInviteeInviteDates(props.groupId, props.campaignId, props.selectedInvitee.inviteeId));
				invitationDates.value = result;
			}
		}, { immediate: true });

		return {
			// Invitation dates
			invitationDates,
			isLoading,
			isError,
			// Util
			Size,
		};
	},
});
